import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { products } from '../data/storeData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const ProductShelf = ({ onAddToCart }) => {
  const [addingId, setAddingId] = useState(null);

  const handleAdd = (product) => {
    setAddingId(product.id);
    // Simulate API delay
    setTimeout(() => {
      onAddToCart(product);
      setAddingId(null);
    }, 600);
  };

  return (
    <section id="shop" className="py-24 md:py-40 bg-stone-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row justify-between items-baseline mb-20 gap-6">
          <div className="max-w-xl">
            <h2 className="font-serif text-4xl md:text-6xl text-stone-900 mb-6">The Curated Shelf</h2>
            <p className="text-stone-500 font-light text-lg">A focused collection of essentials designed to function in perfect harmony.</p>
          </div>
          <div className="flex items-center gap-8">
            <button className="text-[11px] font-bold tracking-[0.2em] uppercase border-b-2 border-stone-900 pb-1">All</button>
            <button className="text-[11px] font-bold tracking-[0.2em] uppercase text-stone-400 hover:text-stone-900 transition-colors">Cleansers</button>
            <button className="text-[11px] font-bold tracking-[0.2em] uppercase text-stone-400 hover:text-stone-900 transition-colors">Serums</button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-16">
          {products.map((product, index) => (
            <motion.div 
              key={product.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group"
            >
              <div className="relative aspect-[4/5] bg-stone-200 mb-6 overflow-hidden">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4 z-10">
                  <span className="bg-white/90 backdrop-blur-sm px-3 py-1 text-[9px] font-bold uppercase tracking-[0.15em] text-stone-900">
                    {product.tag}
                  </span>
                </div>
                
                <button 
                  onClick={() => handleAdd(product)}
                  disabled={addingId === product.id}
                  className={`absolute bottom-0 left-0 w-full py-5 text-[10px] font-bold tracking-[0.2em] uppercase transition-all duration-500 flex items-center justify-center gap-2
                    ${addingId === product.id 
                      ? 'bg-stone-400 text-white translate-y-0' 
                      : 'bg-stone-900 text-white translate-y-full group-hover:translate-y-0'
                    }`}
                >
                  {addingId === product.id ? (
                    <>
                      <SafeIcon icon={FiIcons.FiLoader} className="w-3 h-3 animate-spin" />
                      Processing...
                    </>
                  ) : (
                    <>
                      <SafeIcon icon={FiIcons.FiPlus} className="w-3 h-3" />
                      Add to Bag — ${product.price}
                    </>
                  )}
                </button>
              </div>
              
              <div className="space-y-1">
                <p className="text-[10px] font-bold tracking-widest uppercase text-stone-400">{product.category}</p>
                <h3 className="font-serif text-xl text-stone-900 hover:text-stone-500 cursor-pointer transition-colors">{product.name}</h3>
                <p className="text-sm text-stone-500 font-light line-clamp-2 leading-relaxed">{product.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductShelf;